<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/PM/PMSurveyCheckIn'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fas fa-search-location"></i>
            </span>
            <h3 class="kt-portlet__head-title">ข้อมูลการ Survey PM</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit">
            <div class="row">
              <!-- CR-PM-2026 Issue 40: search col-8 → col-4 to fit 2 date filters (from/to) -->
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="chlKeyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก ชื่อ-สกุลผู้ Survey"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>วันที่ Survey (เริ่มต้น) :</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="วันที่ Survey (วว/ดด/ปปปป)"
                      id="chlCheckInDateFrom"
                      name="chlCheckInDateFrom"
                      ref="chlCheckInDateFrom"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>วันที่ Survey (สิ้นสุด) :</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="วันที่ Survey (วว/ดด/ปปปป)"
                      id="chlCheckInDateTo"
                      name="chlCheckInDateTo"
                      ref="chlCheckInDateTo"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row"> 
              <!-- <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทตัวแทนจำหน่าย :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrAgentTypeCode'"
                    :name="'pmrAgentTypeCode'"
                    :select2-options="pmrAgentTypeCodeOptions"
                    v-model="pmrAgentTypeCode"
                  ></select2>
                </div>
              </div>  -->
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4" v-show="this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrAgentCodes'"
                    :name="'pmrAgentCodes'"
                    :select2-options="pmrAgentCodesOptions"
                    v-model="pmrAgentCodes"
                    ref="pmrAgentCodesSelect2"
                    multiple
                  ></select2> -->
                  <treeselect v-model="pmrAgentCodes" :multiple="true" :options="pmrAgentCodesOptions" :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div> 
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4" v-show="this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])">
                <div class="form-group">
                  <label>ร้านค้า:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrShopCodes'"
                    :name="'pmrShopCodes'"
                    :select2-options="pmrShopCodesOptions"
                    v-model="pmrShopCodes"
                    ref="pmrShopCodesSelect2"
                    multiple
                  ></select2>
                  <p
                    class="text-danger"
                    v-show="this.$root.canShow(['super_admin', 'ADMIN_PM'])"
                  >
                    *ควรเลือกตัวแทนจำหน่ายด้วย
                  </p>
                </div>
              </div> 
            </div>
            <div class="row"> 
            <!-------ตัวแทนย่อย---->
            <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4" v-show="this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])">
                <div class="form-group">
                  <label>ตัวแทนจำหน่ายย่อย:</label>
                  
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrSubAgentCodes'"
                    :name="'pmrSubAgentCodes'"
                    :select2-options="pmrSubAgentCodeOptions"
                    v-model="pmrSubAgentCodes"
                    ref="pmrSubAgentCodesSelect2"
                    multiple
                  ></select2>
 
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4" v-show="this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])">
                <div class="form-group">
                  <label>ร้านค้าตัวแทนจำหน่ายย่อย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrSubAgentShopCodes'"
                    :name="'pmrSubAgentShopCodes'"
                    :select2-options="pmrSubAgentShopCodesOptions"
                    v-model="pmrSubAgentShopCodes"
                    ref="pmrShopCodesSelect2"
                    multiple
                  ></select2>
                  <p
                    class="text-danger"
                    v-show="this.$root.canShow(['super_admin', 'ADMIN_PM'])"
                  >
                    *ควรเลือกตัวแทนจำหน่ายย่อยด้วย
                  </p>
                </div>
              </div>
            <!-------สิ้นสุดตัวแทนย่อย-->
            </div>

            <div class="row">
              <!-- <div class="col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8">
                <div class="form-group">
                  <label>ร้านค้า:</label> -->
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'chlShopIds'"
                    :name="'chlShopIds'"
                    :select2-options="chlShopIdsOptions"
                    v-model="chlShopIds"
                    ref="chlShopIdsSelect2"
                    multiple
                  ></select2> -->
                  <!-- <treeselect
                    v-model="chlShopIds"
                    :multiple="true"
                    :load-options="LoadchlShopIdsOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div> -->

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ผลการดำเนินการ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'chlPMResult'"
                    :name="'chlPMResult'"
                    :select2-options="chlPMResultOptions"
                    v-model="chlPMResult"
                    ref="chlPMResultSelect2"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-10">
                <button type="submit" id="btnSearch" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-2 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportData"
                  type="submit"
                  :disabled="isExporting" >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
               
              </div>
            </div>
 

          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="checkInTable"
              >
                <thead>
                  <tr>
                    <th class="all" width="10%">วันที่ Survey<br />Check-in/out</th>
                    <th class="all" width="10%">ชื่อรูท</th>
                    <th class="all" width="20%">ตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย</th>
                    <th class="all" width="20%">ประเภทตัวแทนจำหน่าย </th>
                    <th class="all" width="20%">ชื่อ-สกุลผู้ Survey</th>
                    <th class="all" width="15%">ร้านค้า</th>
                    <th class="all" width="15%">ร้านค้า 2</th>
                    <th class="all" width="10%">ผลการดำเนินการ</th>
                    <th class="all" width="20%">เหตุผล</th>
                    <th class="all" width="10%">บันทึก</th>
                    <th width="15%" class="all">รายละเอียดการจับชุดอุปกรณ์</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
import datepicker from "../../Shared/Datepicker";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let Action = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="detailBarcodeMapping" v-if="data.showDetailButton" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-file-text"></i>
    </a>
  </div>`,
  methods: {
    detailBarcodeMapping: function() {
      router.push({
        path: `/PM/PMSurveyCheckIn/${this.data.pmSurveyCheckInId}/PMSurveyBarcodeMappingDetail/${this.data.shopId}/${(this.data.subAgentShopCode!=null) ? this.data.subAgentShopCode : 0}`,
      });
    },
  },
});
// CR-PM-2026 Req 1: Reason cell + icon to view checkout media (Survey)
let ActionReason = Vue.extend({
  // CR-PM-2026 Req 3 update: icon = fa-camera-retro #ffb822 stack vertical (icon above text)
  // CR-PM-2026 Issue 15: ลด padding/margin ของ anchor → ไม่ใช้ btn-icon-md / btn-sm
  template: `
  <div style="display:flex; flex-direction:column; align-items:center;">
    <a href="#" v-if="data.showMediaIcon" @click.prevent="viewMedia(data)"
       title="แสดงภาพถ่าย/ลายเซ็น" style="padding:0; margin:0; line-height:1; display:inline-block; cursor:pointer;">
       <i class="fa fa-camera-retro fa-lg" style="color:#ffb822;"></i>
    </a>
    <span>{{ data.reasonForFailedWork }}</span>
  </div>`,
  methods: {
    viewMedia: function(row) {
      // 2026-08-26 (item 2.1): ชื่อไฟล์ปุ่ม "ดาวน์โหลดรูปภาพ" = pattern เดียวกับหน้า ViewImage gallery
      var isSub = row.agentTypeCode == "SUB_AGENT";
      var agentName = (isSub ? row.subAgentName : row.agentName) || "";
      var shop2Name = (isSub ? row.subAgentShopName2 : row.shopName2) || "";
      var dlBase = ["ข้อมูล Survey", shop2Name, agentName, "ออกไม่สำเร็จ"]   // 2026-08-27: สลับ ร้าน2 มาก่อนตัวแทน (เฉพาะ Survey)
        .map(function(s) { return (s || "").trim(); })   // 2026-08-30: trim กัน space ท้ายชื่อร้านจาก DB ติดมาในชื่อไฟล์
        .filter(function(s) { return s; }).join("_");
      axios.get('/Api/PM/CheckoutMedia', { params: { pmSurveyCheckInId: row.pmSurveyCheckInId } })
        .then(function(res) {
          var d = res.data || {};
          // CR-PM-2026 Issue 13: title ชิดซ้าย (move ใส่ html, ปล่อย swal title ว่าง)
          var titleHtml = '<div style="text-align:left; font-size:1.4em; font-weight:600; margin-bottom:15px; color:#212529;">ภาพถ่าย/ลายเซ็น</div>';
          // CR-PM-2026 Issue 13: subtitle gray (#6c757d) แทน #5867dd
          var subtitleHtml = d.mediaTitle
            ? '<div style="text-align:left; color:#6c757d; font-weight:600; margin-bottom:10px;">' + d.mediaTitle + '</div>'
            : '';
          var imgHtml = '';
          var firstFileInfoId = null;
          var firstName = 'download.jpg';
          if (d.files && d.files.length > 0) {
            d.files.forEach(function(f) {
              if (!firstFileInfoId && f.fileInfoId) { firstFileInfoId = f.fileInfoId; firstName = f.fileName || firstName; }
              // CR-PM-2026 Issue 13: padding 0 20px รอบรูป (ไม่ให้รูปติดขอบ modal)
              imgHtml += '<div style="margin-bottom:10px; text-align:center; padding:0 20px;">'
                       + '<img src="' + (f.url || '') + '" style="max-width:100%;max-height:450px;" />'
                       + '</div>';
            });
          } else {
            imgHtml = '<div class="text-muted">ไม่พบไฟล์แนบ</div>';
          }
          // CR-PM-2026 Issue 13: label "หมายเหตุ" gray
          var noteHtml = '<div class="mt-3" style="text-align:left;"><strong style="color:#6c757d;">หมายเหตุ</strong>'
                       + '<div style="border:1px solid #ebedf2;padding:8px;border-radius:4px;margin-top:4px;min-height:40px;">'
                       + (d.exitNote || '') + '</div></div>';
          // CR-PM-2026 Issue 13: buttons เป็น outline-secondary
          // CR-PM-2026: ใช้ backend proxy /Api/File/FileDownloadByte (same-origin, default ContentType=octet-stream → force download)
          //   pattern same as BudgetPlanJobCreate.downloadFile
          // item 2.1: ใช้ชื่อตาม pattern ViewImage + คง extension เดิมของไฟล์ต้นทาง
          var extMatch = /(\.[a-zA-Z0-9]{1,5})$/.exec(firstName || "");
          var dlFileName = dlBase + (extMatch ? extMatch[1] : ".jpg");
          var dlUrl = firstFileInfoId
            ? ('/Api/File/FileDownloadByte?FileInfoId=' + encodeURIComponent(firstFileInfoId) + '&FileName=' + encodeURIComponent(dlFileName))
            : null;
          var footerHtml = '<div style="text-align:right; margin-top:15px;">'
                         + (dlUrl ? ('<a href="' + dlUrl + '" download="' + dlFileName + '" class="btn btn-outline-secondary mr-2"><i class="la la-save"></i> ดาวน์โหลดรูปภาพ</a>') : '')
                         + '<button type="button" id="btn-close-media-popup" class="btn btn-outline-secondary"><i class="la la-times"></i> ปิดหน้าต่าง</button>'
                         + '</div>';
          swal.fire({
            html: titleHtml + subtitleHtml + imgHtml + noteHtml + footerHtml,
            width: '650px',
            showCloseButton: true,
            showConfirmButton: false,
            onOpen: function() {
              var btn = document.getElementById('btn-close-media-popup');
              if (btn) btn.addEventListener('click', function() { swal.close(); });
            }
          });
        })
        .catch(function() {
          swal.fire('ผิดพลาด', 'ไม่สามารถโหลดข้อมูลได้', 'error');
        });
    }
  }
});

let ActionRemark = Vue.extend({
  template: `
  <div>
    {{data.pmRemark}}&nbsp;
    <a href="#" @click.prevent="AddRemark(data.checkInId,data.pmSurveyCheckInId,data.pmRemark)" v-if="data.showRemarkButton" data-id="data.checkInId" title="หมายเหตุ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
       <i class="la la-edit"></i>
    </a>
  </div>`,
  methods: {
    AddRemark: function(id,surveyId,currentRemark) {
       var remark_checkin_id = id ;
       swal.fire({
        title: 'หมายเหตุ',
        html: $('<form id="frmRemark"  ></form>').html('\
                <div class="form-group">' +
                    '<input type="text" id="txtremark" class="form-control" name="txtremark" value="'+((currentRemark!=null) ? currentRemark : "")+'" maxlength="100"/>' +                    
                '</div>' 
                ),
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'บันทึกข้อมูล',
        showCloseButton: true,
        allowOutsideClick: false,        
        preConfirm: () => {    
             
            var valid = true; 
            if(valid)
            {
                var dataForm = new FormData($('#frmRemark')[0]);  
                var remark = $("#frmRemark :input[name='txtremark']").val() ;   
                console.log(dataForm);                 
                valid = false;
 

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
                });

              let router = this.$router;
              let self = this;

              axios
                .post('/Api/PMSurvey/SurveyCheckIn/AddRemark' , {CheckInId: id, SurveyCheckInId : surveyId, Remark: remark})
                .then(function(response) {
              
                  if (response.data) {
                    KTApp.unblockPage();
                    Swal.fire("สำเร็จ", response.data.message, "success").then(function() {
                      //router.go(-1), 
                      self.$parent.reloadDataTable(false);
                    });
                  } else {
                    //console.log(response);
                    Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                  }
                })
                .catch(function(error) {
                  Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                })
                .then(function() {
                  // always executed
                  KTApp.unblockPage();
                });
                }    
                    return false;
                }
            });  
    },
  },
});

export default {
  components: {
    select2,
    datepicker,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      isExporting: false, // 2026-08-10: disable ปุ่ม Export ระหว่างประมวลผล (กันกดซ้ำ)
      chlKeyword: null,
      // Issue 40: date range (from/to)
      chlCheckInDateFrom: moment().startOf("month"), // 2026-08-09: default เดือนปัจจุบัน (1 → วันนี้)
      chlCheckInDateTo: moment(),
      chlShopIds: [],
      chlShopIdsOptions: [],
      chlPMResult: null,

      pmrAgentCodes: [],
      pmrShopCodes: [],  
      pmrSubAgentCodes : [],
      pmrSubAgentCodeOptions : [],
      pmrSubAgentShopCodes : [],
      pmrSubAgentShopCodesOptions : [],
      
      pmrAgentCodesOptions: [],
      // pmrAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: self.$root.canShow(["AGENT_ADMIN_PM"])
      //       ? "/Api/Agents/AgentOptions"
      //       : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         agentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      // pmrAgentTypeCodeOptions: {
      //   placeholder: "กรุณาเลือกประเภทตัวแทนจำหน่าย",
      //   allowClear: false,
      //   data: [
      //     { id: "AGENT", text: "ตัวแทนจำหน่าย", data: null },
      //     { id: "SUB_AGENT", text: "ตัวแทนจำหน่ายย่อย", data: null },
      //   ],
      // },
      pmrShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.pmrAgentCodes,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },

      
      pmrSubAgentShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
         //pmrSubAgentCodes
        ajax: {
          url: "/Api/Shop/SubShopOptionAlertReport",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = { 
              agentCodes : self.pmrAgentCodes, 
              shopCodes  : self.pmrSubAgentCodes,
              search: params.term,
              page: params.page || 1,
              all: true,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      pmrSubAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.pmrAgentCodes,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 

 
      chlPMResultOptions: {
        placeholder: "กรุณาเลือกผลการดำเนินการ",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "PM_RESULT",
              keySearch: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formReset: function(e) {
      let self = this;
      self.chlKeyword = null;
      self.chlCheckInDateFrom = moment().startOf("month"); // 2026-08-09: reset กลับ default เดือนปัจจุบัน
      self.chlCheckInDateTo = moment();
      self.chlShopIds = [];
      self.chlPMResult = null;

      self.pmrAgentCodes = [];
      self.pmrShopCodes = []; 
      self.pmrSubAgentCodes  = []; 
      self.pmrSubAgentShopCodes = []; 

      $("#pmrSubAgentCodes")
        .val("")
        .trigger("change");

      $("#pmrSubAgentShopCodes")
        .val("")
        .trigger("change");

        $("#pmrAgentCodes")
        .val("")
        .trigger("change");

      $("#pmrShopCodes")
        .val("")
        .trigger("change");

      // 2026-08-09: reset → แสดง default เดือนปัจจุบัน (แทนการ clear เป็นว่าง)
      $("#chlCheckInDateFrom").datepicker("update", self.chlCheckInDateFrom.format("DD/MM/YYYY"));
      $("#chlCheckInDateTo").datepicker("update", self.chlCheckInDateTo.format("DD/MM/YYYY"));

      // $("#chlShopIds")
      //   .val("")
      //   .trigger("change");

      $("#chlPMResult")
        .val("")
        .trigger("change");

      self.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#checkInTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#checkInTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    LoadchlShopIdsOptions({ action, searchQuery, callback }) {
      var self = this;
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/Shop/Select2ShopAgent", {
            page: 1,
            all: true,
            search: searchQuery,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.chlShopIdsOptions = [];
              data.forEach((element) => {
                self.chlShopIdsOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });

              callback(null, self.chlShopIdsOptions);
            }
          })
          .catch(function(error) {});
      }
    }, 
    exportData: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      // var curentShop = [];
      // if (
      //   self.OdCurrentLocationSubAgent.length != 0 ||
      //   self.OdCurrentLocationShop.length
      // ) {
      //   curentShop = self.OdCurrentLocationSubAgent.concat(
      //     self.OdCurrentLocationShop
      //   );
      // }
      /*
      var idDate = $("#chlCheckInDate").val();
            if (idDate == null || idDate == "") self.chlCheckInDate = null;

            let jsonSearch = {
              SearchKeyword: self.chlKeyword,
              CheckInDate:
                self.chlCheckInDate != null
                  ? self.chlCheckInDate.format("DD/MM/YYYY")
                  : self.chlCheckInDate,
              AgentCodes: self.pmrAgentCodes ,//chlShopIds,
              ShopIds: self.pmrShopCodes ,//chlShopIds,
              SubAgentShopIds: self.pmrSubAgentShopCodes,//chlShopIds,
              SubAgentCodes: self.pmrSubAgentCodes  ,//chlShopIds,
              PMResult: self.chlPMResult, 
            };
            return JSON.stringify($.extend(d, jsonSearch));
      */

      self.isExporting = true;
      axios({
        method: "post",
        url: "/Api/PMSurvey/SurveyCheckIn/Export",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: self.chlKeyword,
              CheckInDateFrom:
                self.chlCheckInDateFrom != null
                  ? self.chlCheckInDateFrom.format("DD/MM/YYYY")
                  : self.chlCheckInDateFrom,
              CheckInDateTo:
                self.chlCheckInDateTo != null
                  ? self.chlCheckInDateTo.format("DD/MM/YYYY")
                  : self.chlCheckInDateTo,
              AgentCodes: self.pmrAgentCodes ,
              ShopIds: self.pmrShopCodes ,
              SubAgentShopIds: self.pmrSubAgentShopCodes,
              SubAgentCodes: self.pmrSubAgentCodes  ,
              PMResult: self.chlPMResult,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];
            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }
            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลคงค้างเกินกำหนดหรือไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          KTApp.unblockPage();
          self.isExporting = false;
        });
    },
    LoadpmrAgentCodesOptions: function(e) {
      var self = this;
      axios
        .post(
          self.$root.canShow(["AGENT_ADMIN_PM"])
            ? "/Api/Agents/AgentOptions"
            : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
          {
            province_id: [],
            department: [],
            agentCodes: [],
            page: 1,
            all: true,
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.pmrAgentCodesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;

    self.LoadpmrAgentCodesOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    // Issue 40: init 2 datepickers (from + to)
    var dpOptions = {
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(),
      maxDate: moment().add(30, "days"),
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    };
    $(self.$refs.chlCheckInDateFrom).datepicker(dpOptions);
    $(self.$refs.chlCheckInDateFrom).on("changeDate", function(e) {
      self.chlCheckInDateFrom = e.date ? moment(e.date) : null;
    });
    $(self.$refs.chlCheckInDateTo).datepicker(dpOptions);
    $(self.$refs.chlCheckInDateTo).on("changeDate", function(e) {
      self.chlCheckInDateTo = e.date ? moment(e.date) : null;
    });
    // 2026-08-09: แสดง default เดือนปัจจุบันในช่อง datepicker (jQuery ไม่ bind กับ Vue model)
    if (self.chlCheckInDateFrom) $(self.$refs.chlCheckInDateFrom).datepicker("update", self.chlCheckInDateFrom.format("DD/MM/YYYY"));
    if (self.chlCheckInDateTo) $(self.$refs.chlCheckInDateTo).datepicker("update", self.chlCheckInDateTo.format("DD/MM/YYYY"));

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#checkInTable");
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/PMSurvey/SurveyCheckIn/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            // Issue 40: date range — clear stale state if input was cleared
            var idDateFrom = $("#chlCheckInDateFrom").val();
            if (idDateFrom == null || idDateFrom == "") self.chlCheckInDateFrom = null;
            var idDateTo = $("#chlCheckInDateTo").val();
            if (idDateTo == null || idDateTo == "") self.chlCheckInDateTo = null;

            let jsonSearch = {
              SearchKeyword: self.chlKeyword,
              CheckInDateFrom:
                self.chlCheckInDateFrom != null
                  ? self.chlCheckInDateFrom.format("DD/MM/YYYY")
                  : self.chlCheckInDateFrom,
              CheckInDateTo:
                self.chlCheckInDateTo != null
                  ? self.chlCheckInDateTo.format("DD/MM/YYYY")
                  : self.chlCheckInDateTo,
              AgentCodes: self.pmrAgentCodes ,//chlShopIds,
              ShopIds: self.pmrShopCodes ,//chlShopIds,
              SubAgentShopIds: self.pmrSubAgentShopCodes,//chlShopIds,
              SubAgentCodes: self.pmrSubAgentCodes  ,//chlShopIds,
              PMResult: self.chlPMResult,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[0, "desc"]],
        columns: [
          {
            data: "checkInDate",
            // CR-PM-2026 Req 2 — dt-control toggles expand row showing วันที่ Check-Out
            className: "text-center dt-control",
            render: function(data, type, full, meta) {
              return full.checkInDateFormat;
            },
          },
          { data: "routeName", className: "text-center" },
          {
            data:   "agentName" ,
            className: "text-center",
            width: "15%", 
            render: function(data, type, full, meta) {
              if(full.agentTypeCode == "SUB_AGENT"){
                return (full.subAgentName!=null) ? full.subAgentName : "" ;
              }
              else{
                return (full.agentName!=null) ? full.agentName : "" ;
              }
              
            },
          },  
          {
            data: "agentTypeCode",
            className: "text-center",
            width: "10%",
            render: function(data, type, full, meta) {
              return full.agentTypeName;
            },
          },
         
          { data: "checkInByUserFullName", className: "text-center" },
          {
            data:   "shopName" ,
            className: "text-center",
            width: "15%", 
            render: function(data, type, full, meta) {
              if(full.agentTypeCode == "SUB_AGENT"){
                return (full.subAgentShopName!=null) ? full.subAgentShopName : "" ;
              }
              else{
                return (full.shopName!=null) ? full.shopName : "" ;
              }
              
            },
          },  
          {
            data:   "shopName2" ,
            className: "text-center",
            width: "15%", 
            render: function(data, type, full, meta) {
              if(full.agentTypeCode == "SUB_AGENT"){
                return (full.subAgentShopName2!=null) ? full.subAgentShopName2 : "" ;
              }
              else{
                return (full.shopName2!=null) ? full.shopName2 : "" ;
              }
              
            },
          },  

          // { data: "shopName", className: "text-center" },
          // { data: "shopName2", className: "text-center" },
          { data: "workStatusText", className: "text-center" },
          {
            data: "reasonForFailedWork",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="reason_actions"></div>';
            },
          },
          {
            data: "checkInItemId",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="remark_actions"></div>';
            },
          },
          {
            data: "checkInItemId",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          //console.log(data);
          if (data) {
            data.showDetailButton = 
              self.$root.canShow([
                "ADMIN_PM",
                "AGENT_ADMIN_PM", 'SUB_AGENT_ADMIN_PM' ,
                "COOL_SERVICE_PM",
              ]);
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
        // CR-PM-2026 Req 1: Mount ActionReason in เหตุผล column (Survey)
        $(".reason_actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el).parents("tr").first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showMediaIcon = (data.workStatusText === 'ดำเนินการไม่สำเร็จ');
            new ActionReason({ data: { data }, parent: self }).$mount(el);
          }
        });
        $(".remark_actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          //console.log(data);
          if (data) { 
            data.showRemarkButton = self.$root.canShow([
                "ADMIN_PM",
                "super_admin", 
              ]);
            new ActionRemark({ data: { data }, parent: self }).$mount(el);
          }
        });
      });

    // CR-PM-2026 Req 2 — Expand/collapse row to show วันที่ Check-Out (mirror BudgetPlanJobList pattern)
    $("#checkInTable tbody").on("click", "td.dt-control", function () {
      var tr = $(this).closest("tr");
      var row = table.DataTable().row(tr);
      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass("shown");
      } else {
        var d = row.data();
        if (d) {
          var checkout = d.quitShopDateFormat ? d.quitShopDateFormat : "-";
          row.child(
            '<div style="background:#f9f9f9; padding:8px 16px;">' +
            '<strong>วันที่ Check-Out:</strong> ' + checkout +
            '</div>'
          ).show();
          tr.addClass("shown");
        }
      }
    });
    //table.trigger("draw.dt"); //call ajax delete this row
  },
};
</script>

<style lang="scss">
/* CR-PM-2026 Req 2 — +/- icon for expand/collapse (mirror BudgetPlanJobList) */
/* NOTE: non-scoped — DataTable creates td.dt-control dynamically without data-v-xxx attr */
td.dt-control {
  cursor: pointer;
}
td.dt-control::before {
  content: "+";
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 1.5px solid #5d78ff;
  border-radius: 50%;
  font-size: 14px;
  font-weight: bold;
  color: #5d78ff;
  margin-right: 5px;
  line-height: 1;
}
tr.shown td.dt-control::before {
  content: "\2212"; /* minus sign */
}
</style>



// WEBPACK FOOTER //
// App/Components/PM/SearchSurveyCheckIn.vue